// @flow
import React, { Component } from 'react';
//Styles
import './AddBeforeExistsButton.css';

type Props = {
  loading: boolean,
  clickable?: boolean,
  largeSize?: Boolean,
  addItem: (productId: number, quantity: number) => void,
  handleAddGiftCard?: () => boolean,
  isOutOfStock?: boolean,
};

class AddBeforeExistsButton extends Component {
  props: Props;
  constructor(props: Props) {
    super(props);
    this.state = {
      clickable:
        this.props.clickable !== undefined ? this.props.clickable : true,
    };
  }

  render() {
    const { isOutOfStock } = this.props;

    const handleClick = () => {
      if (!this.state.clickable || isOutOfStock) return;

      if (this.props.handleAddGiftCard) {
        this.props.handleAddGiftCard();
        return;
      }
      this.props.addItem();
    };

    if (this.props.loading) {
      return (
        <div
          className={`add-to-cart-before-button ${this.props.largeSize ? 'add-to-cart-before-button-large' : ''}`}
        >
          <i className="fa fa-spinner fa-pulse" />
        </div>
      );
    }

    return (
      <button
        className={`add-to-cart-before-button ${this.props.largeSize ? 'add-to-cart-before-button-large' : ''} ${isOutOfStock ? 'out-of-stock' : ''}`}
        onClick={this.state.clickable && !isOutOfStock ? handleClick : null}
        disabled={isOutOfStock}
      >
        <div
          className={`add-to-cart-before-button-text ${this.props.largeSize ? 'add-to-cart-before-button-text-large' : ''}`}
        >
          <p>{isOutOfStock ? 'Indisponível' : 'Adicionar'}</p>
          {!isOutOfStock && <i className="fa fa-sharp fa-light fa-plus"></i>}
        </div>
      </button>
    );
  }
}

export default AddBeforeExistsButton;
